// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_Fya","cls2":"Comments-cls2_FzQ Comments-cls1_Fya","short":"Comments-short_j1s"};